export default (stringColor) => {
    const rgbStringRegExp = /rgb(a)*\((\s*\d{1,3}\s*\,*){3,4}\)/;
    const digitalRegExp = /\d{1,3}/g
    let rgbValue = stringColor.match(rgbStringRegExp);
    if (!rgbValue) {
        return [0,0,0];
    }
    const rgbColors = rgbValue[0].match(digitalRegExp);
    return rgbColors.map(strDigit => parseInt(strDigit));
}